function BoxIcon({ size = '25', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9591 0.608474L22.2897 4.71104C23.4352 5.22386 24.06 6.2495 24.06 7.3777V17.1213C24.06 18.3521 23.331 19.3777 22.2897 19.8905L13.9591 23.9931C13.5426 24.1982 13.1261 24.3008 12.6054 24.3008C12.1889 24.3008 11.6682 24.1982 11.2517 23.9931L2.92113 19.8905C1.77567 19.3777 1.15088 18.2495 1.15088 17.1213V7.3777C1.15088 6.2495 1.77567 5.22386 2.81699 4.71104L11.1476 0.608474C12.0848 0.198217 13.1261 0.198217 13.9591 0.608474ZM12.6054 2.2495C12.5013 2.2495 12.293 2.2495 12.1889 2.35206L4.48311 6.14693L12.6054 10.1469L20.7277 6.14693L13.022 2.35206C12.9178 2.2495 12.8137 2.2495 12.6054 2.2495ZM3.75418 18.1469C3.44179 17.9418 3.23352 17.5315 3.23352 17.2239V7.78796L11.5641 11.8905V21.9418L3.75418 18.1469ZM13.6467 21.9418L21.3525 18.1469C21.7691 17.9418 21.9773 17.6341 21.9773 17.2239V7.78796L13.6467 11.8905V21.9418Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-10.3037"
          y1="12.3008"
          x2="13.6704"
          y2="35.1851"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <clipPath id="clip0">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.150879 0.300781)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BoxIcon;
